import { Action } from 'redux';

import { ILabelValueInfo } from '~src/catalog/models/ILabelValueInfo';

import { SetLabelValue } from '../../../bootstrap/redux/actions/AppActionTypes';

/**
 * Redux action to open the label value edit dialog (release 262).
 * Unified action that replaces SetCertificationOrTriggerWarning and
 * SetSensitiveOrWarningLabelValue. The dialog behavior is determined by
 * LabelTypeConfig in catalog-ui, not by which action type is dispatched.
 */
export interface SetLabelValueAction extends Action {
  item: ILabelValueInfo;
}

export function setLabelValueAction(item: ILabelValueInfo): SetLabelValueAction {
  return {
    type: SetLabelValue,
    item
  };
}
